module.exports = __webpack_public_path__ + "img/island-modal-icon.3fe1db74.svg";